import React from 'react';
import { Layout } from '../../components';
import Image from 'next/image';
import Link from 'next/link';
import { axiosInstance } from '../../helpers';

function Profile({ companies }) {
  return (
    <Layout title="Companies | slotit.io">
      <div className="max-w-7xl">
        <div className="pb-4">
          <div className="flex-1">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Companies Information
            </h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              These are the available companies.
            </p>
          </div>
          <div></div>
        </div>
        <div className="sm:grid lg:grid-cols-2 xl:grid-cols-3 sm:gap-4 sm:pt-5">
          {companies.map((company) => (
            <div
              className="bg-white border border-gray-200 shadow overflow-hidden sm:rounded-lg"
              key={company.id}
            >
              {company && (
                <div className=" px-4 py-5 sm:p-0">
                  <dl className="sm:divide-y sm:divide-gray-200">
                    <div className="py-2 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-500">
                        Company
                      </dt>
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <div className="flex items-center">
                          <div className="w-8 h-8">
                            {company.logoUrl && (
                              <Image
                                className="inline-block h-9 w-9 rounded-full mr-3"
                                src={company?.logoUrl}
                                alt={company.alias}
                                width="32"
                                height="32"
                              />
                            )}
                          </div>
                          <div className="ml-2">
                            <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                              {company.alias}
                            </p>
                          </div>
                        </div>
                      </dd>
                    </div>
                    <div className="py-2 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-500">
                        Email
                      </dt>
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <div className="flex items-center">
                          <span>{company.user.email}</span>
                        </div>
                      </dd>
                    </div>
                    <div className="py-2 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-500">
                        Phone number
                      </dt>
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <div className="flex items-center">
                          <a href={`tel:${company.user.phoneNumber}`}>
                            {company.user.phoneNumber}
                          </a>
                        </div>
                      </dd>
                    </div>
                    <div className="py-2 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                      <dt className="text-sm font-medium text-gray-500">
                        Address
                      </dt>
                      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <div className="flex items-center space-x-0.5">
                          <span>{company.streetAddress},</span>
                          <span>{company.city},</span>
                          <span>{company.postalCode}</span>
                        </div>
                      </dd>
                    </div>
                    <div className="py-2 sm:py-5 sm:px-6 flex space-x-2">
                      <Link href={`/calendar?companyAlias=${company?.alias}`}>
                        <a className="inline-flex px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                          Calendar
                        </a>
                      </Link>
                      <Link
                        href={`/companies/${company?.alias}/subscription-plans`}
                      >
                        <a className="inline-flex px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                          Subscription plans
                        </a>
                      </Link>
                    </div>
                  </dl>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export async function getServerSideProps(context) {
  let companies = [];
  const axiosService = axiosInstance();

  try {
    const { data } = await axiosService.get(`companies/engine/public`);
    companies = data;
  } catch (error) {
    console.log(error);
  }

  return {
    props: {
      companies,
    },
  };
}

export default Profile;
